<template lang='pug'>
  r-table(
    no-data-text='Sin notas de credito.'
    no-remove
    param-search='number'
    ref='table'
    v-bind='tableProps'
    @detail='selected = $event.item.reset(); dialog = true;'
    )
    template( slot='items' )
      r-dialog(
        content-class='grey lighten-3'
        no-confirm
        title='Nota de credito de venta'
        v-model='dialog'
        )
        r-form(
          class='white'
          v-bind='formProps'
          v-model='selected'
          )
    template( slot='actions' slot-scope='props' )
      r-btn-action( color='grey darken-4' tooltip='PDF' @click='submitPDF(props)' )
        v-icon picture_as_pdf
</template>

<script>
  //
  import { RBtnAction, RDialog, RForm, RTable } from '@/components/reusable_components/next'
  //
  import SlSaleCreditNoteHeaders from '@/views/Sale/SlSaleCreditNote/SlSaleCreditNoteHeaders'
  import SlSaleCreditNoteFields from '@/views/Sale/SlSaleCreditNote/SlSaleCreditNoteFields'
  import SlSaleCreditNoteFilters from '@/views/Sale/SlSaleCreditNote/SlSaleCreditNoteFilters'
  import SlSaleCreditNoteService from '@/services/api/Sale/SlSaleCreditNote'
  //
  export default {
    components: {
      RBtnAction,
      RDialog,
      RForm,
      RTable,
    },
    computed: {
      branchOfficessProps() {
        return {
          noAsyncSearch: true, 
          paramFilter: { 
            sl_customer_id: this.$route.params.id 
          },
        }
      },
      formProps() {
        return {
          editable: false,
          fields: SlSaleCreditNoteFields,
        }
      },
      tableProps() {
        return {
          filters: SlSaleCreditNoteFilters.prop('sl_customer_branch_offices_id', this.branchOfficessProps),
          headers: SlSaleCreditNoteHeaders.get('customer_detail'),
          service: SlSaleCreditNoteService.toCustomerDetail(),
          paramFilter: {
            sl_customer_id: this.$route.params.id,
          },
        }
      },
    },
    data() {
      return {
        dialog: false,
        recent: '',
        selected: null,
      }
    },
    methods: {
      submitPDF(event) {
        event.item.pdf().then(event.item.showFile(`nota de credito ${event.item.id}`, 'pdf'))
      }
    },
  }
</script>
